module.exports = __webpack_public_path__ + "img/6000.7a3ad2e4.jpg";